module.exports = __webpack_public_path__ + "img/Produktion DVS-50.adbe8809.jpg";